;(function (angular, _) {
  'use strict'
  angular.module('kilo.common.services')
    .service('EmailService', EmailService)

  EmailService.$inject = [
    // Angular
    '$http',
    'FileUploader',
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
    'urls',
    'zlAuth',
    '$q',
    'FileManager'
  ]

  function EmailService (
    // Angular
    $http,
    FileUploader,
    // Libs
    // Managers
    // Services
    // Const
    // Resolved
    urls,
    zlAuth,
    $q,
    FileManager
  ) {
    const self = this
    const uploader = new FileUploader({
      url: urls.uploader + '/upload',
      autoUpload: true,
      alias: 'files',
      withCredentials: false
    })

    _.extend(self, {
      sendEmail,
      uploader: uploader,
      getCompanyEmail,
      getUserEmail,
      setUserEmail,
      setCompanyEmail,
      checkConnection,
      checkCompanyInfo,
      uploadAttachment,
      downLoadAttachment,
      getToken
    })

    function sendEmail (payload) {
      return $http({
        url: `${urls.backendEmail}/email`,
        method: 'POST',
        data: payload,
        ignoreErrors: [400],
        headers: { 'Content-Type': 'application/json' }
      })
    }

    function getCompanyEmail () {
      return $http({
        url: `${urls.api}/zenlabs/companies/email/sender`,
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      })
    }

    function setCompanyEmail (emailSender) {
      return $http({
        url: `${urls.api}/zenlabs/companies/email/sender`,
        method: 'PUT',
        data: emailSender,
        headers: { 'Content-Type': 'application/json' }
      })
    }

    function getUserEmail () {
      return $http({
        url: `${urls.api}/zenlabs/users/email/sender`,
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      })
    }

    function setUserEmail (emailSender) {
      return $http({
        url: `${urls.api}/zenlabs/users/email/sender`,
        method: 'PUT',
        data: emailSender,
        headers: { 'Content-Type': 'application/json' }
      })
    }

    function checkConnection (type) {
      return $http({
        url: `${urls.backendEmail}/email/${type}`,
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      })
    }

    function checkCompanyInfo () {
      return $http({
        url: `${urls.api}/zenlabs/companies//email/isConnected`,
        method: 'GET',
        headers: { 'Content-Type': 'application/json' }
      })
    }

    function uploadAttachment (data) {
      return $http({
        url: `${urls.uploader}/upload`,
        method: 'POST',
        data: data,
        headers: { 'Content-Type': data.type }
      })
    }
    function downLoadAttachment (id) {
      return zlAuth.getToken().then(function (token) {
        const url = `${urls.downloader}/object/${id}`
        return `${url}?token=${token}`
      })
    }
    function getToken() {
      return zlAuth.getToken().then(function (token) {
        return token;
      })
    }
  }
})(window.angular, window._)
